import moment from 'moment'

const updateTimer = (v) => {
    var nowTime = moment().locale('en');
    var startTime = moment().locale('en');
    if(v.props.active.start){
        startTime = moment(v.props.active.start).locale('en');
    }
    
    var duration = moment.duration(nowTime.diff(startTime));

    var hours = parseInt(duration.asHours(), 10);
    var minutes = parseInt(duration.asMinutes(), 10)-hours*60;
    var seconds = parseInt(duration.asSeconds(), 10)-minutes*60-hours*3600;
    v.setState({
        s:('0' + seconds).slice(-2), 
        m:('0' + minutes).slice(-2), 
        h:hours,
        endTime: nowTime.format('HH:m')
    });
    if(v.props.active.name){
        document.title =  v.props.active.name + ' - ' + hours + ":" + ('0' + minutes).slice(-2) + ":" + ('0' + seconds).slice(-2)
    }else{
        document.title =  'بدون عنوان - ' + hours + ":" + ('0' + minutes).slice(-2) + ":" + ('0' + seconds).slice(-2)
    }
    
}

const removeTimer = (v)=> {
    clearInterval(v.timerCountDown);
    v.setState({ s:'00', m:'00', h:'0', start : false})
    document.title = 'سامانه مدیریت زمان هنگام'
}

export const startTimer = (v)=> {
    updateTimer(v)
    v.timerCountDown = setInterval( ()=>{
        if(v.props.active.start){
            updateTimer(v)
        }else{
            removeTimer(v)
        }
        
    }, 1000);
}

export const stopTimer = (v)=> {
    removeTimer(v)
}
